import React, { useState } from 'react';
import {
    Dialog,
    DialogContent,
    Grid,
    Typography,
    Box,
    TextField,
    Button,
} from '@mui/material';
import { motion } from "framer-motion";

interface props {
    open: boolean;
    handleClose: () => void;
    handleConfirmCode: (code: string) => void;
    COLOR?: string;
}

export const InsertCodeDialog: React.FC<props> = ({
    open,
    handleClose,
    handleConfirmCode,
    COLOR
}) => {

    const [code, setCode] = useState('');

    const handleInsertCodeSubmit = (event: any) => {
        event.preventDefault();
        if (code.trim()) {
            handleConfirmCode(code.trim());
            setCode('');
        }
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="xs"
            PaperProps={{
                sx: {
                    borderRadius: 4,
                    paddingY: 1,
                    boxShadow:
                        "0px 10px 25px rgba(0,0,0,0.15), 0px 4px 12px rgba(0,0,0,0.08)",
                },
            }}
        >
            <DialogContent sx={{ p: 4 }}>
                <motion.div
                    initial={{ opacity: 0, scale: 0.9, y: 10 }}
                    animate={{ opacity: 1, scale: 1, y: 0 }}
                    transition={{ duration: 0.35 }}
                >
                    <Grid
                        container
                        direction="column"
                        justifyContent="center"
                        alignItems="center"
                        sx={{ textAlign: 'center' }}
                    >
                        {/* TITOLO MIGLIORATO */}
                        <Typography
                            component="h1"
                            variant="h5"
                            fontWeight="700"
                            sx={{
                                background:
                                    "linear-gradient(90deg, #0056D2, #007BFF)",
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent",
                                mb: 2,
                            }}
                        >
                            Verifica Email
                        </Typography>

                        <Typography
                            variant="body1"
                            color="text.secondary"
                            sx={{ mb: 3, maxWidth: 280 }}
                        >
                            Inserisci il codice di verifica che ti abbiamo inviato per email.
                        </Typography>

                        {/* FORM */}
                        <Box
                            id="insertCodeForm"
                            component="form"
                            noValidate
                            onSubmit={handleInsertCodeSubmit}
                            sx={{ width: '100%' }}
                        >
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                id="code"
                                type="number"
                                label="Codice"
                                name="code"
                                onChange={e => setCode(e.target.value)}
                                value={code}
                                inputProps={{
                                    style: {
                                        textAlign: 'center',
                                        fontSize: "1.3rem",
                                        letterSpacing: "2px",
                                    }
                                }}
                                sx={{
                                    "& .MuiOutlinedInput-root": {
                                        borderRadius: 3,
                                        fontWeight: "600",
                                    },
                                }}
                            />

                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                }}
                                mt={3}
                            >
                                <Button
                                    type="submit"
                                    variant="contained"
                                    fullWidth
                                    sx={{
                                        borderRadius: '40px',
                                        py: 1.4,
                                        background:
                                            "linear-gradient(90deg, #0056D2, #007BFF)",
                                        fontWeight: "700",
                                        letterSpacing: "0.5px",
                                        fontSize: "1rem",
                                        boxShadow:
                                            "0px 4px 12px rgba(0, 98, 255, 0.25)",
                                        ":hover": {
                                            background:
                                                "linear-gradient(90deg, #004BB5, #006BE0)",
                                        },
                                    }}
                                >
                                    CONFERMA
                                </Button>
                            </Box>
                        </Box>
                    </Grid>
                </motion.div>
            </DialogContent>
        </Dialog>
    );
};

export default InsertCodeDialog;
